<template>
  <div class="personal-invoice">
    <!-- 个人发票说明 -->
    <div class="info">
      <i class="el-icon-warning-outline"></i>
      <span class="m-l-8">个人票适用于增值服务类</span>
    </div>

    <!-- 发票编辑表单 -->
    <div class="personal-invoice-form">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-suffix="："
        label-width="120px"
        label-position="right"
      >
        <el-form-item label="收票人手机号" prop="employeeMobile">
          <span v-if="readOnly">{{ invoiceInfo.employeeMobile || '-' }}</span>
          <el-input
            v-else
            v-model.trim="form.employeeMobile"
            placeholder="请输入收票人手机号"
            maxlength="11"
          />
        </el-form-item>
        <el-form-item label="收票人邮箱" prop="employeeEmail">
          <span v-if="readOnly">{{ invoiceInfo.employeeEmail || '-' }}</span>
          <el-input
            v-else
            v-model.trim="form.employeeEmail"
            placeholder="请输入收票人邮箱"
            maxlength="50"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 发票操作栏 -->
    <div class="personal-invoice-operation">
      <el-button v-if="readOnly" @click="editInvoice">修改</el-button>
      <template v-else>
        <el-button v-if="invoiceInfo.id" @click="cancel">取消</el-button>
        <el-button type="primary" @click="saveInvoice">保存</el-button>
      </template>
    </div>
  </div>
</template>

<script>
// 接口
import {
  changePersonalInvoiceApi,
  getPersonalInvoiceApi
} from '@/api/financial/invoice'
// 工具
import { formValid } from 'jczh-ui'
import { cloneDeep } from 'loadsh/lang'
import { isCompanyDict } from '@/dictionary/financial'

/**
 * @description 个人发票信息组件
 */
export default {
  name: 'PersonalInvoice',

  data() {
    return {
      readOnly: true,

      // 发票信息
      invoiceInfo: {},
      // 发票表单
      form: {
        // 收票人手机号
        employeeMobile: '',
        // 收票人邮箱
        employeeEmail: ''
      },
      rules: {
        employeeMobile: [
          {
            required: true,
            message: '请输入收票人手机号',
            trigger: 'blur'
          },
          formValid.mobileRegular
        ],
        employeeEmail: [
          {
            required: true,
            message: '请输入收票人邮箱',
            trigger: 'blur'
          },
          formValid.emailRegular
        ]
      }
    }
  },

  created() {
    this.setInvoiceData()
  },

  methods: {
    /**
     * 获取发票信息
     */
    setInvoiceData() {
      getPersonalInvoiceApi()
        .then(res => {
          this.invoiceInfo = res.data || {}
          this.$emit('getInvoiceInfo', this.invoiceInfo)
          if (!this.invoiceInfo.id) this.readOnly = false
        })
        .catch(err => {
          console.error('获取个人发票信息失败：', err)
          if (err?.data?.message) this.$message.error(err.data.message)
        })
    },

    /**
     * 编辑发票信息
     */
    editInvoice() {
      this.form = cloneDeep(this.invoiceInfo)
      this.readOnly = false
    },

    /**
     * 取消编辑
     */
    cancel() {
      this.readOnly = true
    },

    // 表单校验
    async validInvoiceForm() {
      try {
        await this.$refs.form.validate()
        return true
      } catch (err) {
        this.$message.error('表单填写有误，请按照提示要求填写')
        return false
      }
    },

    /**
     * 保存发票信息
     */
    async saveInvoice() {
      try {
        if (!(await this.validInvoiceForm())) return
        await this.$confirm('是否保存电子发票信息', '系统提示', {
          type: 'warning'
        })
        const data = {
          employeeMobile: this.form.employeeMobile,
          employeeEmail: this.form.employeeEmail
        }
        if (this.form.id) {
          data.id = this.form.id
        }
        await changePersonalInvoiceApi(data)
        this.$message.success('保存成功')
        await this.setInvoiceData()
        this.readOnly = true
      } catch (err) {
        if (err?.data) {
          this.$message.error(err?.data?.message || '保存失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-invoice {
  .info {
    color: $text-third-color;
  }

  // 编辑表单
  .personal-invoice-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 24px;

    ::v-deep .el-form {
      width: 400px;
      .el-form-item {
        margin-bottom: 20px;
      }

      &.detail-form {
        .el-form-item {
          margin-bottom: 0;
        }
      }
    }
  }

  // 操作栏
  .personal-invoice-operation {
    text-align: center;
  }
}
</style>
